module.exports = __webpack_public_path__ + "img/4.b730f718.png";